export enum DigitalLogType {
  Any = 0,
  FedExLinehaul = 1,
  FedExSpot = 2,
  Hourly = 3,
  Daily = 4,
  FedExPnD = 5,
  TimeClock = 6,
  Break = 7,
  WorkShift = 8,
  ELD = 9
}

export const TripFilter: DigitalLogType[] = [
  DigitalLogType.FedExLinehaul,
  DigitalLogType.FedExSpot,
  DigitalLogType.FedExPnD
];

//Filter until schedule supports everything
export const ScheduleLogFilter: DigitalLogType[] = [
  DigitalLogType.Hourly,
  DigitalLogType.Daily,
  DigitalLogType.FedExPnD,
  DigitalLogType.TimeClock,
  DigitalLogType.Break
];

export const HourlyLogTypes: DigitalLogType[] = [
  DigitalLogType.Hourly,
  DigitalLogType.TimeClock,
  DigitalLogType.Break,
  DigitalLogType.ELD
];

export const ReconcilableLogTypes: DigitalLogType[] = [
  DigitalLogType.FedExLinehaul,
  DigitalLogType.FedExSpot,
  DigitalLogType.FedExPnD
];

//Filter until schedule supports everything
export const LogTypesDispatched: (DigitalLogType | string)[] = [
  DigitalLogType.FedExLinehaul,
  DigitalLogType.FedExLinehaul.toString(),
  DigitalLogType.FedExSpot,
  DigitalLogType.FedExSpot.toString()
];

export const DigitalLogTypeMapping: Record<DigitalLogType, string> = {
  [DigitalLogType.Any]: 'Unknown',
  [DigitalLogType.FedExLinehaul]: 'FedEx Linehaul',
  [DigitalLogType.FedExSpot]: 'FedEx Spot',
  [DigitalLogType.Hourly]: 'Hourly',
  [DigitalLogType.Daily]: 'Daily',
  [DigitalLogType.FedExPnD]: 'FedEx P&D',
  [DigitalLogType.TimeClock]: 'Time Clock',
  [DigitalLogType.Break]: 'Break',
  [DigitalLogType.WorkShift]: 'Work Shift',
  [DigitalLogType.ELD]: 'ELD'
};

export const DigitalLogTypeFilterNameMapping: Record<DigitalLogType, string> = {
  [DigitalLogType.Any]: 'Any',
  [DigitalLogType.FedExLinehaul]: 'FedEx Linehaul',
  [DigitalLogType.FedExSpot]: 'FedEx Spot',
  [DigitalLogType.Hourly]: 'Hourly',
  [DigitalLogType.Daily]: 'Daily',
  [DigitalLogType.FedExPnD]: 'FedEx P&D',
  [DigitalLogType.TimeClock]: 'Time Clock',
  [DigitalLogType.Break]: 'Break',
  [DigitalLogType.WorkShift]: 'Work Shift',
  [DigitalLogType.ELD]: 'ELD'
};

export const DigitalLogTypeFilterMapping: Record<DigitalLogType, string> = {
  [DigitalLogType.Any]: "EBO.Models.SharedTools.DigitalLogType'Any'",
  [DigitalLogType.FedExLinehaul]: "EBO.Models.SharedTools.DigitalLogType'FedExLinehaul'",
  [DigitalLogType.FedExSpot]: "EBO.Models.SharedTools.DigitalLogType'FedExSpot'",
  [DigitalLogType.Hourly]: "EBO.Models.SharedTools.DigitalLogType'Hourly'",
  [DigitalLogType.Daily]: "EBO.Models.SharedTools.DigitalLogType'Daily'",
  [DigitalLogType.FedExPnD]: "EBO.Models.SharedTools.DigitalLogType'FedExPnD'",
  [DigitalLogType.TimeClock]: "EBO.Models.SharedTools.DigitalLogType'TimeClock'",
  [DigitalLogType.Break]: "EBO.Models.SharedTools.DigitalLogType'Break'",
  [DigitalLogType.WorkShift]: "EBO.Models.SharedTools.DigitalLogType'WorkShift'",
  [DigitalLogType.ELD]: "EBO.Models.SharedTools.DigitalLogType'ELD'"
};

export const DigitalLogTypeUserFriendlyMapping: Record<DigitalLogType, string> = {
  [DigitalLogType.Any]: 'Any',
  [DigitalLogType.FedExLinehaul]: 'Linehaul',
  [DigitalLogType.FedExSpot]: 'Spot',
  [DigitalLogType.Hourly]: 'Hourly',
  [DigitalLogType.Daily]: 'Daily',
  [DigitalLogType.FedExPnD]: 'P&D',
  [DigitalLogType.TimeClock]: 'Time Clock',
  [DigitalLogType.Break]: 'Break',
  [DigitalLogType.WorkShift]: 'Work Shift',
  [DigitalLogType.ELD]: 'ELD'
};
